<div class="model-comparison">
  <app-page-header>Model comparison</app-page-header>
  <div class="container header-container">
    <div class="card">
      <div class="header">Take care to check:</div>
      <div class="content">
        <div class="care-to-check">
          <div class="text">
            <dgx-components-icon
              [family]="'light'"
              [name]="'circle-check'"
            ></dgx-components-icon>
            <div>
              <span class="highlight">Size: </span>
              <span>will the product fit where you want it?</span>
            </div>
          </div>
          <div class="text">
            <dgx-components-icon
              [family]="'light'"
              [name]="'circle-check'"
            ></dgx-components-icon>
            <div>
              <span class="highlight">Delivery: </span>
              <span
                >will it fit through any doors or halls (in its
                packaging)?</span
              >
            </div>
          </div>
          <div class="text">
            <dgx-components-icon
              [family]="'light'"
              [name]="'circle-check'"
            ></dgx-components-icon>
            <div>
              <span class="highlight">Construction: </span>
              <span>will it be built into your units, or freestanding?</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container body-container">
    <div class="content">
      <div class="grid-row mobile-back-button">
        <div class="xs-4">
          <a
            (click)="routeBack()"
            class="back-button link typog-body-large-bold"
            ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
          >
        </div>
      </div>
      <div class="grid-row">
        <div class="xs-12">
          <div class="card">
            <div class="container p-none table-comparison">
              <div class="grid-row pt-5">
                <div class="md-2">
                  <a
                    (click)="routeBack()"
                    (keydown.enter)="routeBack()"
                    (keydown.space)="routeBack(); $event.preventDefault()"
                    tabindex="0"
                    class="back-button link typog-body-large-bold"
                    ><i class="fa-solid fa-arrow-left mr-1"></i>Back</a
                  >
                </div>
                <div class="xs-12 md-8">
                  <h5>
                    Use the columns to compare each product’s specifications
                  </h5>
                </div>
                <div class="md-2"></div>
              </div>

              <div class="grid-row no-gap">
                <div
                  *ngFor="let comparison of comparisons; index as index"
                  class="compare-card p-none"
                  [ngClass]="{
                    'xs-6': comparisons.length === 2,
                    'xs-4': comparisons.length === 3,
                    first: index === 0,
                    middle: comparisons.length > 2 && index === 1,
                    last: comparisons.length === index + 1
                  }"
                >
                  <div class="header" [ngClass]="{ new: index > 0 }">
                    {{ index < 1 ? 'Current' : 'New ' + index }}

                    <dgx-components-button
                      *ngIf="index > 0"
                      variant="secondary"
                      size=""
                      aria-label="Remove comparison"
                      (click)="removed.emit(comparison)"
                    >
                      <dgx-components-icon
                        [family]="'light'"
                        [name]="'close'"
                      ></dgx-components-icon>
                    </dgx-components-button>
                  </div>
                  <div class="content">
                    <div class="image">
                      <img
                        [src]="
                          (comparison.images && (comparison?.images)[0]?.url) ||
                          imageNotAvailable
                        "
                        [attr.alt]="
                          comparison.images && comparison.images[0]?.text
                            ? comparison.images[0].text
                            : 'Product image showing ' + comparison.make
                        "
                      />
                    </div>
                    <p class="typog-body-bold">
                      {{ comparison?.make }}
                    </p>
                    <p class="typog-body">
                      {{ comparison.appliance_category }}
                    </p>
                    <div class="container p-none">
                      <div class="grid-row">
                        <div class="xs-6">
                          <p class="hint">
                            <span class="highlight">Colour: </span>
                            {{ comparison.colour }}
                          </p>
                          <ng-container
                            *ngIf="
                              comparison?.offer_type === offerType.REPLACEMENT
                            "
                          >
                            <p class="free">£0.00</p>
                          </ng-container>
                          <ng-container
                            *ngIf="comparison?.offer_type === offerType.UPGRADE"
                          >
                            <p class="upgrade">
                              {{ comparison?.upgrade_fee | currency : 'GBP' }}
                            </p>
                          </ng-container>
                        </div>
                        <div class="xs-6 desktop-only">
                          <dgx-components-button
                            *ngIf="index > 0"
                            fill="true"
                            variant="secondary"
                            (clicked)="selected.emit(comparison)"
                            >Choose</dgx-components-button
                          >
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="index > 0">
                      <dgx-components-button
                        class="mobile-only"
                        fill="true"
                        variant="secondary"
                        (clicked)="selected.emit(comparison)"
                        >Choose</dgx-components-button
                      >
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="grid-row">
                <div class="xs-12">
                  <div class="highlight-differences">
                    <div class="circle"></div>
                    Highlighted differences
                  </div>
                </div>
              </div>
            </div>
            <app-spec-table
              [comparisons]="comparisons"
              [filtered]="showHighlightsOnly"
            ></app-spec-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sticky-element">
    <section class="compare__footer flex align--center justify--center">
      <div class="container flex justify--center align--center">
        <span id="showDifferencesText"> <h5>Only show differences</h5> </span>

        <!-- Rounded switch -->
        <label class="switch">
          <input
            type="checkbox"
            [(ngModel)]="showHighlightsOnly"
            aria-labelledby="showDifferencesText"
          />
          <span class="slider round" aria-hidden="true"> </span>
        </label>
      </div>
    </section>
  </div>
</div>
